import { memo } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { DropZoneRow, DropZoneText } from '../CustomPage.styled';

interface PanelGridRowDropZoneProps {
  readonly rowIndex: number;
}

const messages = defineMessages({
  dropHere: {
    id: 'customPageDropHere',
    defaultMessage: 'Drop here to create a new row'
  }
});

const PanelGridRowDropZoneComponent = ({ rowIndex }: PanelGridRowDropZoneProps) => {
  const intl = useIntl();

  return (
    <DropZoneRow data-testid={`panel-grid-row-drop-zone-${rowIndex}`}>
      <DropZoneText>{intl.formatMessage(messages.dropHere)}</DropZoneText>
    </DropZoneRow>
  );
};

export const PanelGridRowDropZone = memo(PanelGridRowDropZoneComponent);
